module.exports = __webpack_public_path__ + "src/assets/img/phones.c8242499.png";